import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import GuidedPathOverview from './GuidedPathOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchGuidedPathOverview } from './companyGuidedPathApi';

/**
 * Route wrapper for the Guided Path overview. Scoping comes from the token and
 * the sidebar toggle; the department filter narrows the whole page.
 */
const CGuidedPathOverview = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    () => fetchGuidedPathOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Guided Path | Shoorah</title>
      </Helmet>
      <GuidedPathOverview
        fetcher={fetcher}
        basePath={`/${slug}/guided-path`}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CGuidedPathOverview;
